module.exports = __webpack_public_path__ + "img/1.28254738.jpg";